import { createFileRoute } from "@tanstack/react-router";

import Access from "~/pages/Administration/Grants";
import { parseAccessSearch } from "~/utils/grants";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/administration/access")({
  staticData: ROUTE_STATIC.administration,
  validateSearch: parseAccessSearch,
  component: Access,
});
